import SuperAdminLayout from "SuperAdmin/SuperAdminLayout/SuperAdminLayout"
import SettingsNav from "SuperAdmin/SuperAdminNav/SettingsNav"



const LoginPageSettings = () =>{
    return<>
    <SuperAdminLayout>

        <SettingsNav />

        <h1> Login Page Settings</h1>


    </SuperAdminLayout>
    
    </>
}
export default LoginPageSettings